<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Redeem E-Coupon</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Redeem Section -->
    <form @submit.prevent="redeem">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-2 fit-content">E-Coupon Code*</label>
                <div class="col-md-3 pl-0">
                  <input
                    type="text"
                    v-model="code"
                    class="form-control"
                    maxlength="50"
                    required
                  />
                </div>
                <div class="col-md-1">
                  <button class="btn btn-primary">Redeem</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- /Redeem Section -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      code: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  methods: {
    redeem() {
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to redeem the code?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.redeemFlexibleEcoupon({ code: this.code }, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.code = "";
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Merchant/RedeemEcoupon.vue